import { render, staticRenderFns } from "./CadastroEndereco.vue?vue&type=template&id=4fb58c34&"
import script from "./CadastroEndereco.vue?vue&type=script&lang=js&"
export * from "./CadastroEndereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports